import ProjectsList from './ProjectsList'

export default ProjectsList


// WEBPACK FOOTER //
// ./resources/assets/js/components/ProjectsList/index.js